import React, { useMemo } from "react";
import { Card } from "react-bootstrap";
import { Doughnut } from "react-chartjs-2";
import { FaUser } from "react-icons/fa";
import { CORES_PADRAO_PIE } from "./utils";

const pieOptions = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: { position: "bottom", labels: { boxWidth: 12, font: { size: 11 }, padding: 10 } },
    tooltip: { callbacks: { label: (ctx) => ` ${ctx.label}: ${ctx.parsed} arquivo(s)` } },
  },
};

function DistribuicaoPorResponsavel({ porResponsavel }) {
  const pieData = useMemo(
    () => ({
      labels: (porResponsavel || []).map((r) => r.nome_responsavel),
      datasets: [
        {
          data: (porResponsavel || []).map((r) => r.quantidade),
          backgroundColor: (porResponsavel || []).map((_, i) => CORES_PADRAO_PIE[i % CORES_PADRAO_PIE.length]),
          borderColor: (porResponsavel || []).map((_, i) => CORES_PADRAO_PIE[i % CORES_PADRAO_PIE.length]),
          borderWidth: 2,
          hoverOffset: 6,
        },
      ],
    }),
    [porResponsavel]
  );

  if (!porResponsavel || porResponsavel.length === 0) return null;

  return (
    <Card className="h-100">
      <Card.Header className="fw-semibold d-flex align-items-center gap-2">
        <FaUser size={16} className="text-primary" />
        Distribuição por Responsável
      </Card.Header>
      <Card.Body>
        <div style={{ height: 280 }}>
          <Doughnut data={pieData} options={pieOptions} />
        </div>
      </Card.Body>
    </Card>
  );
}

export default DistribuicaoPorResponsavel;
